<template>
  <navbar />
  <!-- partial -->
  <div class="container-fluid page-body-wrapper">
    <!-- partial:partials/_sidebar.html -->
    <sidebar />
    <!-- partial -->
    <div class="main-panel">
      <div class="content-wrapper">
        <div class="row">
          <div class="col-md-12 grid-margin">
            <div class="row">
              <div class="col-12 col-xl-8 mb-4 mb-xl-0">
                <h3 class="font-weight-bold">Dashboard</h3>
              </div>
              <div class="col-12 col-xl-4">
                <div class="justify-content-end d-flex">
                  <div class="dropdown flex-md-grow-1 flex-xl-grow-0">
                    <button class="btn btn-sm btn-light bg-white dropdown-toggle" type="button" id="dropdownMenuDate2" data-bs-toggle="dropdown" aria-haspopup="true" aria-expanded="true">
                      <i class="mdi mdi-calendar"></i> Today (10 Jan 2021) </button>
                    <div class="dropdown-menu dropdown-menu-right" aria-labelledby="dropdownMenuDate2">
                      <a class="dropdown-item" href="#">January - March</a>
                      <a class="dropdown-item" href="#">March - June</a>
                      <a class="dropdown-item" href="#">June - August</a>
                      <a class="dropdown-item" href="#">August - November</a>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
        <div class="row">
          <div class="col-md-12 grid-margin transparent">
            <div class="row">
              <div class="col-md-2 mb-4 stretch-card transparent">
                <div class="card card-tale" style="border-radius: 12px;" >
                  <div class="card-body px-3 py-3">
                    <p class="fs-30 mt-3 mb-3">{{ this.citizenCount }}</p>
                    <router-link class="nav-link active" to="/citizens"><p class="fs-5 mb-2">House Hold and Others</p></router-link>
                  </div>
                </div>
              </div>
              <div class="col-md-2 mb-4 stretch-card transparent">
                <div class="card card-tale" style="border-radius: 12px;" >
                  <div class="card-body px-3 py-3">
                    <p class="fs-30 mt-3 mb-3">{{ this.wardCount }}</p>
                    <router-link class="nav-link active" to="/ward"><p class="fs-5 mb-2">Wards</p></router-link>
                  </div>
                </div>
              </div>
              <div class="col-md-2 mb-4 stretch-card transparent">
                <div class="card card-tale" style="border-radius: 12px;" >
                  <div class="card-body px-3 py-3">
                    <p class="fs-30 mt-3 mb-3">{{ this.roadCount }}</p>
                    <router-link class="nav-link active" to="/road"><p class="fs-5 mb-2">Roads</p></router-link>
                  </div>
                </div>
              </div>
              <div class="col-md-2 mb-4 stretch-card transparent">
                <div class="card card-tale" style="border-radius: 12px;" >
                  <div class="card-body px-3 py-3">
                    <p class="fs-30 mt-3 mb-3">{{ this.blockCount }}</p>
                    <router-link class="nav-link active" to="/block"><p class="fs-5 mb-2">Blocks</p></router-link>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
        
      </div>
      <!-- content-wrapper ends -->
      <!-- partial:partials/_footer.html -->
      <footer class="footer">
        <div class="d-sm-flex justify-content-center justify-content-sm-between">
            <span class="text-muted text-center text-sm-left d-block d-sm-inline-block">Copyright © 2023. Premium <a href="" target="_blank"></a> All rights reserved.</span>
            <span class="float-none float-sm-right d-block mt-1 mt-sm-0 text-center"></span>
        </div>
      </footer>
      <!-- partial -->
    </div>
    <!-- main-panel ends -->
  </div>
</template>

<script>
  import Navbar   from '../layouts/navbar.vue';
  import Sidebar  from '../layouts/sidebar.vue';
  import Api      from '../util/Api';
  import Chokidar from '../util/Chokidar';

  export default {
    components: {
      navbar: Navbar,
      sidebar: Sidebar,
    },
    data() {
      return {
        citizenCount : 0,
        wardCount    : 0,
        roadCount    : 0,
        blockCount   : 0
      }
    },

    methods:{
      getCitizenCount(){
        Api().get('/count-data')
        .catch((error) => {
          if (error.response.status == 401) {
            localStorage.removeItem('token');
            localStorage.removeItem('guard');
            this.$swal({
              icon: 'error',
              title: 'Session Expired, please login!',
              toast: true,
              position: 'top-end',
              showConfirmButton: false,
              timer: 4000
            });
            this.$router.push('/login');
          } 
        }).then(response =>{
          this.citizenCount = response.data.citizenCount;
          this.wardCount    = response.data.wardCount;
          this.roadCount    = response.data.roadCount;
          this.blockCount   = response.data.blockCount;
        });
      },
    },
    created()
    {
      if(Chokidar() != 'user'){
        this.$router.push('/login');
      }else{
        this.getCitizenCount();
      }
    }
  }
</script>